import { Pipe, PipeTransform } from '@angular/core';
import { RevisionStatus } from '../models/autogenerated-coating';
import { RevisionStatusHelper } from '../models/revision-status.model';

@Pipe({
  name: 'revisionStatus',
  standalone: false
})
export class RevisionStatusPipe implements PipeTransform {

  transform(value: RevisionStatus | number, type: 'display' | 'text' | 'cssClass' = 'display'): string {
    if (value === null || value === undefined) {
      return '';
    }

    switch (type) {
      case 'display':
        return RevisionStatusHelper.getDisplayName(value);
      case 'text':
        return RevisionStatusHelper.getInternalText(value);
      case 'cssClass':
        return RevisionStatusHelper.getCssClass(value);
      default:
        return RevisionStatusHelper.getDisplayName(value);
    }
  }
}
